import {Component, OnInit} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {CrudUserService} from '../../../../shared/services/crud-user.service';
import {IDisplayColumn} from '@shared/library/crud-library/crud-list/crud-list.component';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {ShareddataService} from '@shared/services/shareddata.service';
import {GlobalsService} from '@shared/services/globals.service';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {

  observabledata: Observable<any>;
  displayedcolumns: IDisplayColumn[] = [];
  entityroot: string;

  constructor(protected httpcrud: CrudUserService, // Specific
              protected modalservice: BsModalService,
              private router: Router,
              protected globalsservice: GlobalsService,
              protected sharedData: ShareddataService,
  ) {
    this.entityroot = '/admin/users';
  } // constructor

  text_truncate(str, length = 70, ending = '...') {
    if (length == null) {
      length = 70;
    }
    if (ending == null) {
      ending = '...';
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  } // text_truncate


  ngOnInit() {

    this.observabledata = this.httpcrud.getEntities();

    // update the user list in the data store when it's fetched
    this.httpcrud.getEntities().subscribe(({results}) => {
      // gets the user list
      this.sharedData.setUsers(results);
    });

    this.displayedcolumns = [
      {columnName: 'id', label: 'ID'},
      {columnName: 'username', isKeyColumn: true, label: 'Username'},
      {columnName: 'email', label: 'e-mail'},
      {columnName: 'contactnr', label: 'Contact Nr'},
      {columnName: 'last_login', label: 'Last login'},
      {columnName: 'active', label: 'Active'},
      {columnName: 'tool-edit-button', label: ''}
    ] as IDisplayColumn[];
  }

  getObservableData() {
    return this.observabledata;
  }

  getPostTreatmentCallback() {
    return (data) => data.results.filter(u => u.deleted === 0).map(user => {
      user.last_login = user.last_login !== null ?
        this.globalsservice.convertDateFormatFromDb(user.last_login.date, 'YYYY-MM-DD HH:mm:ss') : '';
      return user;
    });
  }

  getListEditPathCallback() {
    return (idvalue) => this.entityroot + '/' + idvalue + '/edit';
  }

  getCreateLink() {
    return [this.entityroot + '/create'];
  } // getCreateLink


  deleteEntityHandler() {
    return (idvalue) => this.httpcrud.removeEntity(idvalue);
  } // deleteEntityHandler

  deletePostTreatmentHandler() {
    return (idvalue, entityroot) => {
      // removes user from list
      this.sharedData.setUsers(this.sharedData.getUsers().filter(u => u.id !== idvalue));
      // Refresh same page
      this.router.navigateByUrl('/', {skipLocationChange: true})
        .then(() => this.router.navigate([entityroot]));
    };
  } // deletePostTreatmentHandler

  editUserTools(id) {
    const editUserToolConfig = this.entityroot + '/' + id + '/usertoolconfigs';
    this.router.navigate([editUserToolConfig]);
  }

}
